import { analyticEvent, inlineErrorEvent, onLoadErrorEvent, overlayEvent } from './common';

const unsubSmsText = 'marketing preferences: unsubscribe from all sms button';
export const unsubscribeFromAllSms = analyticEvent(unsubSmsText);
export const unsubscribeFromAllSmsError = inlineErrorEvent(unsubSmsText);
export const unsubscribeFromAllSmsSuccess = analyticEvent('mktg pref:sms list>n');

export const noPhoneOverlay = overlayEvent('subscribe to text messages no phone');

export const useAccountPhoneOverlay = overlayEvent('use account phone number');

export const confirmConsentOverlay = overlayEvent('confirm your consent overlay');

const confirmConsentText = 'sms: confirm your consent button';
export const confirmConsentEvent = analyticEvent(confirmConsentText);
export const confirmConsentError = inlineErrorEvent(confirmConsentText);

export const smsRetrievePageLoadError = onLoadErrorEvent('sms preferences');

export const confirmOverlay = overlayEvent('please confirm your unsubscribe request');
